import {flattenUsers, mergeProperties, reverseEnum} from "../components/Utility";
import {Status} from "../enums/enums";

export const  getFormData = (data) => {
    const initialData = {
        name: '',
        branchType: '',
        address: {
            street: "",
            city: "",
            state: "",
            zipCode: "",
            country: ""
        },
        restaurant: '',
        location: {
            type: 'Point',
            coordinates: {
                latitude: "",
                longitude: "",
            },
        },

        googlePlaceId: '',
        googleReviewLink: '',
        status: ''
    }
    // fill data in initialData from data
    return mergeProperties(initialData, data);
};

export const getTableColumns = ({ActionDropdown,deleteHandler}) => {
    let tableColumns = [
        { header: "Name", field: "name" },
        { header: "Branch Type", field: "branchType" },
        { header: "Restaurant", field: "restaurant" },
        { header: "Status", field: "status" },
    ];

    tableColumns.push({
        header: 'Action',
        disableSorting: true,
        field: 'action',
        align: "right",
        render: (row) => {
            return <ActionDropdown row={row} owners={true} user={true} onDelete={deleteHandler}/>;
        },
    });
    return tableColumns;
};


export const getTableData  = ({items = [], list}) => {
    if (!Array.isArray(items)) return [];
    const {
        items: restaurantItems,
    } = list.restaurant;

    return items.map(item => ({
        id: item.id,
        name: item.name,
        branchType: item.branchType,
        restaurant: restaurantItems[item.restaurant],
        status: reverseEnum(Status)[item.status]
    }));
}

export const getDetailData = ({item}) => {
    if (!item) return { details: {} };

    let users;
    if (item.users) {
        // Create a shallow copy to avoid mutating original
        const { Owner, ...rest } = item.users;
        users = flattenUsers(rest);
    }
    else {
        users = [];
    }
    return {
        details: {
            name: item?.name,
            branchType: item?.branchType,
            address: item.address && Object.keys(item.address).map(key => (`${item.address[key]}`)).join(', '),
            restaurant: item?.restaurant.name,
            googlePlaceId: item?.googlePlaceId,
            googleReviewLink: item?.googleReviewLink,
            status: reverseEnum(Status)[item?.status],
            owners: (
                <ul className="list-unstyled mb-0">
                    {item.users?.Owner && item.users.Owner.map((owner, idx) => (
                        <li key={idx} className="mb-3 p-2 border rounded-3">
                            Name: {owner.fullName}<br />
                            Phone: {owner.phone}<br />
                            Email: {owner.email}<br />
                            Status: {reverseEnum(Status)[owner.status]}<br />
                            Percentage: {owner.stakePercentage}%
                        </li>
                    ))}
                </ul>
            ),
            users: (
                <ul className="list-unstyled mb-0">
                    {users && users.map((user, idx) => (
                        <li key={idx} className="mb-3 p-2 border rounded-3">
                            Name: {user.fullName}<br />
                            Phone: {user.phone}<br />
                            Email: {user.email}<br />
                            Role: {user.role}<br />
                            Status: {reverseEnum(Status)[user.status]}<br />
                        </li>
                    ))}
                </ul>
            ),
        }
    };
}









